import {observer} from 'mobx-react';
import ErrorBlock from "./ErrorBlock";
import {getAvatarUrl} from "./blockUtils";
import {IBlockComponentProps} from "./_Block";
import {getBackgroundImageValue} from "../../../stores/StyleStore";
import {useStores} from "../../../stores/useStores";

interface IPersonBlockProps extends IBlockComponentProps {
    blockObj: IPersonBlock,
}

const PersonBlock = observer((props: IPersonBlockProps) => {
    try {
        const {modalStore} = useStores();
        const {blockObj} = props;

        const modalObj: IPersonModalObj = {
            id: blockObj.blockModel.id,
            type: "schoolBlocksPerson",
            blockObj,
        }

        return (
            <button className="sb-block-container" onClick={() => modalStore.addModal(modalObj)}>
                <table className="sb-teacher-card">
                    <tbody>
                    <tr>
                        <td className="sb-teacher-card-image-cell">
                            <div className="sb-circular-profile-image sb-teacher-img-size-small"
                                 role="presentation"
                                 style={getBackgroundImageValue(getAvatarUrl(blockObj.blockModel))}
                                 title={`${blockObj.blockModel.fname} ${blockObj.blockModel.lname}`}>
                                &nbsp;
                            </div>
                        </td>
                        <td className="sb-teacher-card-info-cell sb-organization-color-block-font">
                            <div className="sb-h1">
                                <span className="sb-teacher-card-name notranslate">{blockObj.blockModel.fname}</span>
                                <span className="sb-teacher-card-name notranslate"> {blockObj.blockModel.lname}</span>
                                <div className="sb-teacher-card-title">
                                    {blockObj.blockModel.title}
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </button>
        )
    } catch (_e: unknown) {
        const e: Error = _e as Error;
        return <ErrorBlock blockObj={{errorMessage: e}} />
    }
});

export default PersonBlock;
